"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VirtualBackgroundUploadError", {
  enumerable: true,
  get: function get() {
    return _VirtualBackgroundUploadError["default"];
  }
});
var _VirtualBackgroundUploadError = _interopRequireDefault(require("./VirtualBackgroundUploadError"));